module.exports = __webpack_public_path__ + "static/media/BovExo_template_animais_lotes.38963d86.xlsx";